import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import SwipeSlider from '../../../../SwipeSlider.v2';
import ShopBlock from './ShopBlock';
import s from './Shops.scss';
const Shops = ({ block, deviation: parentDeviation })=>{
    var _block_users;
    const isMobile = useContext(MobileContext);
    const blocks = (_block_users = block.users) === null || _block_users === void 0 ? void 0 : _block_users.map(({ user, link, deviations })=>user && deviations && /*#__PURE__*/ React.createElement(ShopBlock, {
            block: block,
            key: user.userId,
            user: user,
            deviations: deviations,
            link: link
        }));
    return /*#__PURE__*/ React.createElement(SidebarBlockWrapper, {
        deviation: parentDeviation,
        block: block,
        headerClassName: s['header']
    }, isMobile ? /*#__PURE__*/ React.createElement(SwipeSlider, {
        className: s['swipe-slider']
    }, blocks) : blocks);
};
Shops.displayName = 'Shops';
export default Shops;

//# sourceMappingURL=Shops.js.map